import { Form, Formik } from "formik";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { RideByHourContext } from "../RideByHour/RideByHourContext";
import VehicleTypeModal from "../VehicleTypeModal/VehicleTypeModal";
import { bookingTracking, vehicleSelectTracking } from "../../utils/mixpanel";

/**
 * The Vehicle details step of the ride by hours trip
 *
 * It shows a form containing the following:
 *  - The vehicle name. The options of the cars come from the backend
 *
 * @returns {JSX.Element}
 */

const VehicleDetailsStep = () => {
  const { t } = useTranslation("global");
  const vehicleTypeData = useSelector(
    (state) => state.cachedRequests.vehiclesRequest
  );
  const user = useSelector((state) => state.authData.user);
  const { secondStepValues, setSecondStepValues, setActiveTab } =
    useContext(RideByHourContext);
  const onSubmit = (values) => {
    setSecondStepValues(values);
    bookingTracking({
      user: user?.email,
      service: "Hours",
      step: "Vehicle Details Step",
    });
    setActiveTab(3);
  };
  const vehicles = vehicleTypeData.message;
  if (!vehicleTypeData?.message) {
    return <div className="min-h-24"></div>;
  }
  return (
    <div>
      <Formik
        initialValues={{
          vehicleType:
            secondStepValues.vehicleType || vehicles?.[0]?.short_name,
        }}
        onSubmit={onSubmit}
      >
        {({ values, setFieldValue }) => (
          <Form className="flex flex-col gap-4">
            <VehicleTypeModal
              VehicleTypeWithService={vehicles}
              vehicleTypeName={values.vehicleType}
              setVehicleTypeName={(vehicle) => {
                setFieldValue("vehicleType", vehicle);
                vehicleSelectTracking({
                  user: user?.email,
                  service: "Hours",
                  vehicle,
                });
              }}
            />
            <div className="flex">
              <button
                type="button"
                className="bg-bg_btn_back w-1/2 text-text_white hover:bg-gray-100 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2"
                onClick={() => {
                  setActiveTab(1);
                }}
              >
                {t("previous_text")}
              </button>
              <button
                type="submit"
                className="bg-background_steel_blue w-1/2 text-text_white hover:bg-gray-100 font-medium rounded-lg text-sm px-5 py-2.5 mb-2"
              >
                {t("submit_text")}
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default VehicleDetailsStep;
